import './Loading.css'
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

function Loading() {

    return (
        <div className='loading_div flex align_center justify_center'>

            <svg width={0} height={0}>
                <defs>
                    <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#235539" />
                        <stop offset="100%" stopColor="#a1c7b2" />
                    </linearGradient>
                </defs>
            </svg>
            <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={45} />
        </div>
    );
}

export default Loading;